const state = {
  running: [],
  ended: []
}

const getters = {
  running: state => state.running,
  lastRunning: state => {
    return state.running.length > 0 ? state.running[0] : null
  },
  ended: state => state.ended
}

const actions = {

}

const mutations = {
  add (state, {name}) {
    state.running.push({
      name
    })
  },
  end (state, {name}) {
    state.running = state.running.filter(task => {
      if (task.name === name) {
        // state.ended.push(task)
        return false
      }

      return true
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/app/tasks.js